import React from 'react';

import GameContainer from './GameContainer.js';

import CatchItCanvas from '../games/CatchItCanvas.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import ActionButton from '../builder/ActionButton.js';
import GameScoredInstructions from './GameScoredInstructions.js';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';
import { injectIntl } from 'react-intl';

const Instructions = (props) => {
	const stage = props.stage.Stage;

	if(stage.catch_images.length < 2) return null;

	const score_ranges = {
		ok:{
			score:'+10',
		},
		superok:{
			score:'+50',
			icon:'ep-star',
		},
		ko:{
			score:'-50',
		},
		superko:{
			score:'-5000',
			icon:'ep-death',
		},
	};

	const _superok_images = stage.catch_images.filter((img) => (img.type == 'superok'));
	const _ok_images = stage.catch_images.filter((img) => (img.type == 'ok'));
	const _superko_images = stage.catch_images.filter((img) => (img.type == 'superko'));
	const _ko_images = stage.catch_images.filter((img) => (img.type == 'ko'));

	const ok_images = [ ..._ok_images, ..._superok_images ];
	const ko_images = [ ..._ko_images, ..._superko_images ];

	return (
		<GameScoredInstructions
			stage={stage}
			ok_images={ok_images}
			ko_images={ko_images}
			score_ranges={score_ranges}
		/>
	)
};

const TogglePlayableButton = (props) => {
	return (
		<ButtonCollection
			_class={{ other:'flex_button' }}
		>
			<ActionButton
				_fullclass=""
				onClick={() => props.gameCanvas.current.togglePlay()}
			>Toggle jugability</ActionButton>
		</ButtonCollection>
	)
};

const CatchItClient = ({ stage, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const layout_props = getLayout(props?.promotion ?? {});
	
	const final_stage = clientFinalPage(stage, props.actual_state);

	const instructions_placeholder = `<h1>${i18n("How to play")}</h1><p>${i18n("Collect as many items as you can before they hit the ground to score as many points as possible. Be careful! Avoid negative items that will substract points.")}</p>`;

	const total_items = stage.Stage?.catch_images ?? [];
	const ok_items = (stage.Stage?.catch_images ?? []).filter((t) => (t.type == 'ok'));

	const catcher_image = (isNotEmpty(stage.Stage, 'full_catch_player_image')) ? true : false;

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			instructions_placeholder={instructions_placeholder}
			game_type="catchit"
			display_attemps={false}
			display_audio_controls={true}
			auto_start_timer={false}
			instructions_has_border={false}
			instructions_classes='gui_flex_align_center'
		>
			{(ok_items.length > 0 && catcher_image !== false) ? (
				<CatchItCanvas
					ko_color={layout_props.other.ribbon_closed_background_color}
					ok_color={layout_props.other.ribbon_open_background_color}
				/>
			) : (
				<MisconfiguredGameWarning
					message={(catcher_image !== false) ? ((total_items.length > 0) ? "It's necessary to add at least 1 OK item to be able to create the game" : "Create at least 1 element to generate the game") : "The image to catch the elements is mandatory"}
				/>
			)}
		</GameContainer>
	)
};

export default injectIntl(CatchItClient);